import { Component } from '@angular/core';
import { Action } from '../../models/core/action';
import { LinkLabelComponent } from '../core/labels/link-label.component';

@Component({
  selector: 'app-applications-page',
  imports: [LinkLabelComponent],
  template: `
    @for (item of links; track item) {
      <div class="tw-py-1">
        <app-link-label [routerLink]="item.routerLink">{{
          item.title
        }}</app-link-label>
      </div>
    }
  `,
  styles: ``,
})
export class ApplicationsPageComponent {
  links: Action[] = [
    { title: 'Provider Search Tool' },
    { title: 'Advanced Analytics' },
    { title: 'BO Launchpad' },
  ];
}
